import React from 'react';
import {connect} from "react-redux";
import Button from "@material-ui/core/Button";
import {withRouter} from "react-router-dom";
import {selectDealer, setDealerLocatorRenderFlag, setSearchSort, setZipCode} from "../../core/redux/ActionCreator";
import dealerLocatorService from "../../shared/services/dealerLocatorService";
import Header from "../component/Header/Header";
import Dealer from "../component/dealer";
import LocationSearchBar from "../component/locationSearchBar";
import Map from "../component/map";
import {compose} from "redux";
import UseCurrentLocationButton from "../component/useCurrentLocationButton";
import searchResultsService from "../../shared/services/searchResultsService";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Offer from "../component/Offers/offer";
import Analytics from "../../shared/util/analytics";
import _ from "lodash";
import ConfirmationModal from "./ConfirmationModal";

class DealerLocator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            analytics: Analytics(),
            brand: 'none',
            confirmationFlag: false,
            dealer: this.props.dealer,
            dealersToShow: 3,
            expanded: false,
            isMobile: window.innerWidth < 768,
            longitude: -97.68194299999999,
            latitude: 30.4570672,
            minWidth: 768,
            range: 50,
            selectedDealer: '',
            viewFlag: false
        };
        if (this.props.pathname !== '') {
            let path = this.props.pathname;
            if (path.toLocaleString().includes('brand') && (this.props.brand !== '')) {
                this.state.brand = this.props.brand
            }
        }
        this.showMore = this.showMore.bind(this);
        this.submitDealer = this.submitDealer.bind(this);
        this.helperSubmit = this.helperSubmit.bind(this);
    }

    componentDidMount() {
        if (this.props.zipCode === ''){
            this.props.history.push("/");
        } else {
            window.addEventListener("resize", this.resize.bind(this));
            if (this.props.adobeFlag) {
                this.state.analytics.trackPage('dealer-locator');
                // eslint-disable-next-line no-undef
                _satellite.track('select-dealer');
                console.log('Analytics Added for Page to DOM: Dealer Locator using JQuery');
            }

            if (this.props.zipCode === 'empty' && this.props.hasResults) {
                dealerLocatorService.getDealersGeoSearch(this.props.currentLatLng.lat, this.props.currentLatLng.lng, this.state.range, this.state.brand);
            }
        }
    }

    resize() {
        this.setState({isMobile: window.innerWidth < 768})
    }

    showMore = () => {
        this.state.dealersToShow === 3 ? (
            this.setState({dealersToShow: this.props.dealers.length, expanded: true})
        ) : (
            this.setState({dealersToShow: 3, expanded: false})
        )
    };

    dealerList() {
        return <>
            {this.props.dealers.slice(0, this.state.dealersToShow).map((item, index) => {
                    const dealerAddressObject = {
                        street: item.street1,
                        city: item.city,
                        state: item.state,
                        zip: item.zip
                    };

                    return (
                        <div className="row" key={index}>
                            <Dealer dealerName={item.dealerName} dealerBac={item.baccode} enrolledDealer={item.inNetwork}
                                    dealerAddressObject={dealerAddressObject}
                                    dealerPhone={item.phoneNumber}/>
                        </div>
                    )
                }
            )}
        </>;
    }

    submitDealer() {
        if (this.props.cart && this.props.cart.length !== 0) {
            this.setState({confirmationFlag: true})
        } else {
            this.helperSubmit();
        }
    }

    helperSubmit() {
        if (this.props.selectedDealer) {
            this.setState({confirmationFlag: false});
            searchResultsService.getResults(this.props.size, this.props.year, this.props.make, this.props.model, this.props.selectedDealer);
            this.props.setSearchSort("Sort By")
            this.props.history.push("/searchResult");
        } else {
            console.log('Dealer not selected');
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!_.isEqual(prevProps.currentLatLng, this.props.currentLatLng)) {
            if ((this.props.zipCode !== '' && this.props.zipCode.match(/^\b\d{5}(-\d{4})?\b$/)) || this.props.zipCode === 'empty') {
                this.props.selectDealer({dealerBAC:''});
                dealerLocatorService.getDealersGeoSearch(this.props.currentLatLng.lat, this.props.currentLatLng.lng, this.state.range, this.state.brand);
            }
        }
        // disable continue when zip or location is changed
        if(prevProps.zipCode !== this.props.zipCode ){
            this.props.selectDealer({dealerBAC:''});
        }

        if (prevState.expanded !== this.state.expanded) {
            this.dealerList();
        }

        if (prevProps.adobeFlag !== this.props.adobeFlag) {
            if (this.props.adobeFlag) {
                this.state.analytics.trackPage('dealer-locator');
                // eslint-disable-next-line no-undef
                _satellite.track('select-dealer');
                console.log('Analytics Added for Page to DOM: Dealer Locator using JQuery');
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    render() {
        return (
            <div>
                <Offer/>
                <div className="dealer-Locator-Container">
                    <div className="dealer-Locator-Header-Container">
                        <Header title='Title' page='/'/>
                        <div className="dealer-Locator-Header-Text">
                            CHOOSE A DEALER
                        </div>
                        <LocationSearchBar/>
                        <UseCurrentLocationButton dataDtm="choose dealer"/>
                    </div>
                    <div className="dealer-locator-body-container">
                        <div className={'hide-on-desktop'}>
                            {(this.state.isMobile) && <Map desktop={false}/>}
                        </div>
                        {!this.props.renderFlag && <div className="dealer-locator-body-loading">
                            <h5>Retrieving Dealers...</h5>
                        </div>}
                        {this.props.googleError && <div className="dealer-locator-body-error">
                            <h5>{this.props.googleError}</h5>
                        </div>}
                        {this.props.renderFlag && this.props.dealers.length === 0 &&
                        <div className="dealer-locator-body-error">
                            <h5>No Dealers Found</h5>
                        </div>}
                        {this.props.renderFlag && !this.props.googleError && this.props.dealers.length !== 0 &&
                        <div className="colFirst dealer-list">
                            <div style={{height: "570px", overflow:"auto"}} >
                                {this.dealerList()}
                            </div>
                            <div>
                                <div
                                    className="showMore stat-text-link"
                                    data-dtm={"choose dealer"}
                                    onClick={this.showMore}
                                >
                                    {
                                        this.state.expanded ? (<span>Show less</span>) : (
                                            <div className={"showMore"}>Show more <ExpandMoreIcon
                                                style={{fontSize: 32}}/></div>)
                                    }
                                </div>
                            </div>
                        </div>}
                        <div className={'hide-on-mobile'}>
                            <div className={'colLast-map-container'}>
                                {(!this.state.isMobile) && <Map desktop={true}/>}
                            </div>
                        </div>
                    </div>
                    <div className="dealer-locator-footer-container">
                        <Button className={'button primary-button stat-button-link'} data-dtm={"choose dealer"}
                                disabled={!this.props.selectedDealer} onClick={this.submitDealer}>
                            Select Dealer
                        </Button>
                        <ConfirmationModal show={this.state.confirmationFlag} onSubmit={this.helperSubmit}/>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        adobeFlag: state.appParamsReducer.adobeScriptLoadFlag,
        brand: state.appParamsReducer.brand,
        cart: state.cartReducer.cart,
        currentLatLng: state.dealerReducer.currentLatLng,
        dealers: state.dealerReducer.dealers,
        googleError: state.dealerReducer.googleMapsError,
        hasResults: state.searchResultReducer.spinner,
        make: state.yearMakeModelReducer.sMake,
        model: state.yearMakeModelReducer.sModel,
        pathname: state.appParamsReducer.pathname,
        renderFlag: state.dealerReducer.renderFlag,
        selectedDealer: state.dealerReducer.selectedDealer,
        size: state.yearMakeModelReducer.sSize,
        year: state.yearMakeModelReducer.sYear,
        zipCode: state.yearMakeModelReducer.zipCode,
    }
};
export default compose(
    withRouter,
    connect(mapStateToProps, {setZipCode, setDealerLocatorRenderFlag, selectDealer, setSearchSort})
)(DealerLocator);